<template>
  <div class="page-con">
    <div class="page-con-header clearfix">
      <Button type="primary" icon="ios-add" style="border-radius: 5px;" v-if="isHavePermission('eleContract:create')"
              @click="showDialog">新建运输合同
      </Button>
      <Button type="primary" @click="batchDownload" icon="md-download"
              v-if="isHavePermission('eleContract:batchDownload')"
              :style="isHavePermission('eleContract:create') ? 'margin-left: 10px;border-radius: 5px;':''">合同批量下载
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh"
                  :style="isHavePermission('eleContract:batchDownload') ? 'margin-left: 10px' :''">刷新
      </vxe-button>
      <div class="search-filter">
        <Poptip placement="bottom-end" width="680" v-model="searchVisible">
          <em>
            <Icon type="ios-search-outline"/>
            搜索
          </em>
          <div class="search-box" slot="content">
            <vxe-form :data="searchFormData" title-align="left">
              <vxe-form-item
                  title="搜索"
                  field="receiveNum"
                  span="24"
                  :prefix="{ icon: 'fa fa-address-card-o' }"
              ></vxe-form-item>
              <vxe-form-item title="合同编号" field="contractNum" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractNum"
                      placeholder="输入合同编号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="合同名称" field="contractName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.contractName"
                      placeholder="输入合同名称"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="托运人" field="palletName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchPalletName"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'palletNameOptions')"
                      placeholder="输入托运人"
                  >
                    <Option
                        v-for="option in palletNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="承运人" field="shipperName" span="12">
                <template v-slot>
                  <Select
                      v-model="searchShipperName"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'shipperNameOptions')"
                      placeholder="输入承运人"
                  >
                    <Option
                        v-for="option in shipperNameOptions"
                        :value="option.text"
                        :key="option.text"
                    >{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="签约日期" field="palletAddTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.palletAddTime"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="车船号" field="shipName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.shipName"
                      placeholder="输入车船号"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="货名" field="goodsName" span="12">
                <template v-slot>
                  <vxe-input
                      v-model="searchFormData.goodsName"
                      placeholder="输入货名"
                  ></vxe-input>
                </template>
              </vxe-form-item>
              <vxe-form-item title="起运日期" field="beginTimeStr" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.beginTimeStr"
                      :options="timeOptions"
                      placeholder="选择时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="业务员" field="salesMan" span="12">
                <template v-slot>
                  <Select
                      v-model="searchSalesMan"
                      multiple
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) => setDefaultOptions(file, 'salesManOptions')"
                      placeholder="输入托运人"
                  >
                    <Option v-for="option in salesManOptions" :value="option.text" :key="option.text">{{ option.text }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建人" field="createUser" span="12">
                <template v-slot>
                  <Select
                      v-model="searchCreateUser"
                      multiple
                      clearable
                      filterable
                      :default-label="[]"
                      :loading="searchLoading"
                      :max-tag-count="1"
                      :max-tag-placeholder="maxTagPlaceholder"
                      @on-set-default-options="(file) =>setDefaultOptions(file,'createUserOptions')"
                      placeholder="输入创建人"
                  >
                    <Option v-for="option in createUserOptions" :value="option.text" :key="option.text">{{ option.text
                      }}
                    </Option>
                  </Select>
                </template>
              </vxe-form-item>
              <vxe-form-item title="创建时间" field="createTime" span="12">
                <template v-slot>
                  <vxe-select
                      v-model="searchFormData.createTime"
                      :options="timeOptions"
                      placeholder="创建时间"
                  ></vxe-select>
                </template>
              </vxe-form-item>
              <vxe-form-item align="right" span="24">
                <template v-slot>
                  <Button status="primary" icon="ios-search" @click="getSearchListKey" style="border-radius: 5px">搜索
                  </Button>
                  <Button @click="reset" style="margin-left: 10px; border-radius: 5px">重置
                  </Button>
                </template>
              </vxe-form-item>
            </vxe-form>
          </div>
        </Poptip>
        <div class="search-filter">
          <vxe-modal
              class="timeModal"
              v-model="open"
              width="460"
              height="400"
              :show-footer="false"
              :showHeader="false"
          >
            <template v-slot>
              <DatePicker
                  :open="open"
                  confirm
                  type="daterange"
                  :split-panels="true"
                  placeholder
                  style="width: 432px"
                  @on-change="handleChange"
                  @on-clear="handleClear"
                  @on-ok="handleOk"
              >
                <span class="date-slot"></span>
              </DatePicker>
            </template>
          </vxe-modal>
        </div>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          ref="xTable"
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          show-overflow
          max-height="740"
          :loading="loading"
          :data="tableData"
          @filter-change="filterChangeMethod"
          @checkbox-all="selectAllEvent"
          @checkbox-change="selectChangeEvent"
      >
        <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
        <vxe-table-column title="操作" width="90">
          <template slot-scope="{ row }">
            <Dropdown trigger="click" style="margin-left: 10px; cursor: pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left: 70px">
                <div style="display: flex; flex-direction: column">
                  <Button class="button-gengduo" v-if="isHavePermission('carriageContract:download') && row.state !== 0"
                          @click="downloadContract(row)">下载
                  </Button>
                  <Button class="button-gengduo"
                          v-if="row.state === 2 && row.msgCount < 2"
                          @click="sendContractUrlMsgPallet(row.id)">催客户签署
                  </Button>
                  <Button class="button-gengduo" v-if="row.state === 2 && isHavePermission('carriageContract:cancel')"
                          @click="commitCancel(row.id)">撤回
                  </Button>
                  <Button class="button-gengduo" @click="commitDelete(row.id)"
                          v-if="row.state === 5 && isHavePermission('carriageContract:delete')"
                          style="color: #ed4014">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractNum" title="合同编号" width="150">
          <template slot-scope="{ row }">
            <a v-if="isHavePermission('carriageContract:view')" @click="viewContract(row)">{{ row.contractNum}}</a>
            <span v-else>{{ row.contractNum}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="contractName" title="合同名称" width="120"></vxe-table-column>
        <vxe-table-column field="state" title="合同状态"
                          :filters="[{label: '待审核', value: 0},{label: '待平台签署', value: 1}, {label: '待签署', value: 2},{label: '已签署', value: 3}, {label: '已拒绝', value: 4},{label: '已撤回', value: 57}]"
                          :filter-multiple="false" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.state | state }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="palletName" title="托运人" width="200"></vxe-table-column>
        <vxe-table-column field="shipperName" title="承运人" width="200"></vxe-table-column>
        <vxe-table-column field="palletAddTime" title="签约日期" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.palletAddTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="shipName" title="车船号" width="100"></vxe-table-column>
        <vxe-table-column field="goodsName" title="货名" width="100"></vxe-table-column>
        <vxe-table-column field="beginTime" title="起运日期" width="150">
          <template slot-scope="{ row }">
            <span>{{ row.beginTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="salesMan" title="业务员" width="200"></vxe-table-column>
        <vxe-table-column field="createUser" title="创建人" width="150"></vxe-table-column>
        <vxe-table-column field="createTime" title="创建时间" width="150">
          <template slot-scope="{ row }">
            <span style="color: #a7adad">{{ row.createTime | timeFormatDate}}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>
    </div>
    <vxe-modal class="proModal" v-model="isShowModal" title="新建运输合同" width="1120" height="950" position="center"
               resize @close="closeModal">
      <create-carriage-contract ref="createModal" @close="close"></create-carriage-contract>
    </vxe-modal>
    <vxe-modal v-model="detailModal" title="合同详情" width="1000" height="900" position="center"
               resize>
      <carriage-contract-detail ref="detailModal" @close="closeDetail"></carriage-contract-detail>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import $C from "@/consts";
  import {SEARCH_TIME} from "@/filters/time";
  import moment from "moment";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import {postBlob, hideLoading, isEmpty, saveBlob, showLoading, blobToJson,} from "@/utils/util";
  import CreateCarriageContract from "@/views/contracts/CreateCarriageContract";
  import CarriageContractDetail from "@/views/contracts/CarriageContractDetail";

  moment.locale("zh-CN");

  export default {
    name: "CarriageContract",
    components: {CreateCarriageContract, CarriageContractDetail},
    mixins: [getAuthOrization],
    data() {
      return {
        searchLoading: false,
        searchVisible: false,
        open: false,
        timeOptions: SEARCH_TIME.options,
        loading: false,
        modalTitle: "",
        tableData: [],
        searchFormData: {
          contractNum: null,
          contractName: null,
          palletAddTime: null,
          shipName: null,
          goodsName: null,
          beginTimeStr: null,
          createTime: null,
          state: null
        },
        page: {
          currentPage: 1,
          pageSize: 10,
          totalResult: 100,
        },
        isShowModal: false,
        valueType: [],
        detailModal: false,
        searchPalletName: [],
        palletNameOptions: [],
        searchShipperName: [],
        shipperNameOptions: [],
        searchSalesMan: [],
        salesManOptions: [],
        searchCreateUser: [],
        createUserOptions: [],
        paramsObj: {
          page: 1,
          rows: 10,
        },
        records: [],
      };
    },
    watch: {
      "searchFormData.palletAddTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("palletAddTime");
        },
      },
      "searchFormData.beginTimeStr": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("beginTimeStr");
        },
      },
      "searchFormData.createTime": {
        deep: true,
        immediate: true,
        handler: function (val, oldVal) {
          this.openRangeDate("createTime");
        },
      },
    },
    filters: {
      state(val) {
        if (val != null) {
          if (val === 0) {
            return "待审核";
          }
          if (val === 1) {
            return "待平台签署";
          }
          if (val === 2) {
            return "待签署";
          }
          if (val === 3) {
            return "已签署";
          }
          if (val === 4) {
            return "已拒绝";
          }
          if (val === 5) {
            return "已撤回";
          }
        }
      },
    },
    mounted() {
      this.getList('', 'palletNameOptions', 'eleContract', 'queryContractPalletKeyword', 1);
      this.getList('', 'shipperNameOptions', 'eleContract', 'queryContractPalletKeyword', 2);
      this.getList('', 'salesManOptions', 'eleContract', 'queryContractPalletKeyword', 3);
      this.getList('', 'createUserOptions', 'eleContract', 'queryContractPalletKeyword', 4);

      this.getContractPalletList(this.paramsObj);
    },
    methods: {
      async batchDownload() {
        let records = this.records;
        if (records.length === 0) {
          this.$XModal.alert({
            message: '请选择至少一条合同信息',
            status: "error",
          });
          return
        }
        let idList = [];
        records.map(i => {
          idList.push(i.id);
        })
        showLoading();
        let res = postBlob("/api/order/electricContract/downAttachFilesPalletFile", {
          ids: idList
        });
        hideLoading()
        await saveBlob(".zip", res.data)
      },
      selectChangeEvent({checked, row}) {
        if (checked) {
          this.records.push(row);
        } else {
          let key = this.records.indexOf(row);
          this.records.splice(key, 1);
        }
      },
      selectAllEvent({checked, records}) {
        if (checked) {
          this.records = records;
        } else {
          this.records = [];
        }
      },
      closeDetail() {
        this.detailModal = false;
      },
      filterChangeMethod({values}) {
        this.page.currentPage = 1;
        if (values.length > 0) {
          this.searchFormData.state = values[0];
        } else {
          this.searchFormData.state = null;
        }
        this.getSearchListKey()
      },
      downloadContract(row) {
        this.downLoad(row.docUrl);
      },
      async downLoad(url) {
        let name = url.substring(url.lastIndexOf("/") + 1)
        let responsePromise = await fetch(url)
        let blob = await responsePromise.blob()
        let objectURL = window.URL.createObjectURL(blob)
        let a = document.createElement('a')
        a.href = objectURL
        a.download = name
        a.click()
        a.remove()
      },
      viewContract(row) {
        this.detailModal = true;
        this.$refs.detailModal.init(row);
      },
      closeModal() {
        this.$refs.createModal.cancel();
      },
      close() {
        this.isShowModal = false;
        this.getSearchListKey();
      },
      showDialog() {
        this.isShowModal = true;
        this.$refs.createModal.init();
      },
      reset() {
        this.searchFormData = {
          contractNum: null,
          contractName: null,
          contractType: null,
          secondPartyPhone: null,
          palletAddTime: null,
          carShipNum: null,
          goodsName: null,
          beginTimeStr: null,
          createTime: null,
          state: null
        };
        this.searchFirstPartyName = [];
        this.searchSecondPartyName = [];
        this.searchSalesMan = [];
        this.searchCreateUser = [];
      },
      openRangeDate(field) {
        if (this.searchFormData[field] === 1) {
          this.rangeTime = field;
          this.open = true;
        } else {
          this.open = false;
        }
      },
      handleChange(date) {
        this.timeVal = date;
        // this.timeVal = date.map( v => moment(v).valueOf());
        console.log(this.timeVal);
      },
      handleClear() {
      },
      handleOk() {
        this.searchFormData[this.rangeTime] = this.timeVal;
        this.rangeTime = false;
        let that = this;
        setTimeout(() => {
          that.searchVisible = true;
        }, 100);
      },
      maxTagPlaceholder(num) {
        return "更多+ " + num;
      },
      remoteMethod(query, options, url, path, columnType) {
        if (query !== "") {
          this.searchLoading = true;
          this.getList(query, options, url, path, columnType);
        } else {
          this[options] = [];
        }
      },
      async getList(query, options, url, path, columnType) {
        let params = {
          columnType: columnType,
          moduleType: 3
        };

        if (!isEmpty(query)) {
          params.keyword = query;
        }
        if (isEmpty(this[options])) {
          this.searchLoading = true;
        }
        let res = await $api[url].post(path, params);
        this.searchLoading = false;
        if (res.status === 1) {
          this[options] = res.data;
        }
      },
      setDefaultOptions(options, option) {
        this[option] = options;
      },
      refresh() {
        this.getSearchListKey();
      },
      async getContractPalletList(obj) {
        this.loading = true;
        let res = await $api.eleContract.request("getContractPalletList", obj);
        if (res.status === 1) {
          this.page.totalResult = res.data.total;
          this.tableData = res.data.rows;
          this.tableData.map((i) => {
            this.records.map((j) => {
              if (i.id === j.id) {
                this.$refs.xTable.setCheckboxRow(i, true);
              }
            });
          });
          this.loading = false;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      getSearchListKey() {
        let obj = this.searchFormData;
        let paramsObj = {};
        Object.keys(obj).forEach((key) => {
          if (
            obj[key] !== null &&
            key !== "createTime" &&
            key !== "beginTimeStr" &&
            key !== "palletAddTime" &&
            obj[key] !== undefined
          ) {
            paramsObj[key] = obj[key];
          }
          if (obj["createTime"] && obj["createTime"].length > 0) {
            paramsObj.createTimeBegin = moment(obj.createTime[0]).valueOf(); // 开始时间
            paramsObj.createTimeEnd =
              moment(obj.createTime[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["beginTimeStr"] && obj["beginTimeStr"].length > 0) {
            paramsObj.beginTimeStrBegin = moment(obj.beginTimeStr[0]).valueOf(); // 开始时间
            paramsObj.beginTimeStrEnd = moment(obj.beginTimeStr[1]).valueOf() + 86399999; // 结束时间
          }
          if (obj["palletAddTime"] && obj["palletAddTime"].length > 0) {
            paramsObj.palletAddTimeBegin = moment(obj.palletAddTime[0]).valueOf(); // 开始时间
            paramsObj.palletAddTimeEnd = moment(obj.palletAddTime[1]).valueOf() + 86399999; // 结束时间
          }
        });
        paramsObj.page = 1;
        paramsObj.rows = this.page.pageSize;
        if (this.searchPalletName.length > 0) {
          paramsObj.palletNameList = this.searchPalletName;
        }
        if (this.searchShipperName.length > 0) {
          paramsObj.shipperNameList = this.searchShipperName;
        }
        if (this.searchSalesMan.length > 0) {
          paramsObj.salesManList = this.searchSalesMan;
        }
        if (this.searchCreateUser.length > 0) {
          paramsObj.createUserList = this.searchCreateUser;
        }
        this.paramsObj = paramsObj;
        this.page.currentPage = 1;
        this.page.pageSize = 10;
        this.getContractPalletList(paramsObj);
        this.searchVisible = false;
      },
      commitCancel(id) {
        this.$XModal.confirm("您确定要撤回吗？").then((type) => {
          if (type === "confirm") {
            this.cancel(id);
          }
        });
      },
      commitDelete(id) {
        this.$XModal.confirm("您确定要删除吗？").then((type) => {
          if (type === "confirm") {
            this.delete(id);
          }
        });
      },
      async sendContractUrlMsgPallet(id) {
        let res = await $api.eleContract.request("sendContractUrlMsgPallet", {
          id: id,
        });
        if (res.status === 1) {
          this.$Message.success("催促成功");
          this.getSearchListKey();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async cancel(id) {
        let res = await $api.eleContract.request("cancelContractPallet", {
          id: id,
        });
        if (res.status === 1) {
          this.$Message.success("撤回成功");
          this.getSearchListKey();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      async delete(id) {
        let res = await $api.eleContract.request("deleteContractPallet", {
          id: id,
        });
        if (res.status === 1) {
          this.$Message.success("删除成功");
          this.getSearchListKey();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      changePage(e) {
        this.page.currentPage = e.currentPage;
        this.page.pageSize = e.pageSize;
        this.paramsObj.page = this.page.currentPage;
        this.paramsObj.rows = this.page.pageSize;
        this.getContractPalletList(this.paramsObj);
      },
    },
  };
</script>

<style scoped>
  .btn-down {
    border: none;
  }

  .btn-down:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
    background: transparent;
  }

  .page-con-header {
    margin-bottom: 10px;
    position: relative;
  }

  .btn-down.ivu-btn {
    background: transparent;
  }

  .btn-down.ivu-btn:hover {
    background: transparent;
  }

  .proModal >>> .vxe-modal--box .vxe-modal--body {
    padding: 0;
    background: #F5F7F9;
  }
</style>
